import { render, staticRenderFns } from "./QuoteImageCategory.vue?vue&type=template&id=534afe19&scoped=true"
import script from "./QuoteImageCategory.vue?vue&type=script&lang=js"
export * from "./QuoteImageCategory.vue?vue&type=script&lang=js"
import style0 from "./QuoteImageCategory.vue?vue&type=style&index=0&id=534afe19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534afe19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534afe19')) {
      api.createRecord('534afe19', component.options)
    } else {
      api.reload('534afe19', component.options)
    }
    module.hot.accept("./QuoteImageCategory.vue?vue&type=template&id=534afe19&scoped=true", function () {
      api.rerender('534afe19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteImageCategory.vue"
export default component.exports